<div class="input-wrapper collapsed" #expandable>
    <div class="template-container">
        <div class="input-header">
            <div class="title">
                From Templates
            </div>
        </div>
        <div class="template-picker">
            <div class="template">
                <kw-row-renderer [data]="row3Data"></kw-row-renderer>
            </div>
            
            <!-- <kw-row-renderer></kw-row-renderer> -->
<!--             <kw-row-renderer></kw-row-renderer> -->
        </div>
    </div>
    <div class="input-container">
        <kve-input-header [title]="title" (onClose)="close($event)"></kve-input-header>
        <div class="input-cell">
            <nb-actions>
                <nb-action>
                    <nb-icon [icon]="collapsed ? 'arrowhead-left-outline' : 'arrowhead-right-outline'"
                        pack="eva" pack="eva" (click)="toggleContainer()">
                    </nb-icon>
                </nb-action>
                <nb-action>
                    Templates
                </nb-action>
            </nb-actions>
        </div>
        <div class="input-cell">
            <div class="description">Maximum 3 cells per row on desktops</div>
            <div class="graphic cell-3" (click)="createGrid(3)">
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Maximum 4 cells per row on desktops</div>
            <div class="graphic cell-4" (click)="createGrid(4)">
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
            </div>
        </div>
        <div class="input-cell">
            <div class="description">Maximum 6 cells per row on desktops</div>
            <div class="graphic cell-6" (click)="createGrid(6)">
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
            </div>
        </div>
    </div>    
</div>
